import Skeleton from 'react-loading-skeleton';
import styles from '../note/Note.module.scss';

export const NoteSkeleton = () => {
  return (
    <div className={styles.note}>
      <div className={styles.header}>
        <div className={styles.created}>
          <Skeleton height={16} width={120} />
          <Skeleton height={16} width={120} />
        </div>
      </div>
      <Skeleton height={80} />
    </div>
  );
};

export default NoteSkeleton;
